import React, { useCallback, Children, useState, useEffect, useMemo, useRef, isValidElement, cloneElement, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { createMemoStyles, visuallyHidden, defaultFonts, safeRest, defaultBaseline, uniqueId, KEYS } from '@wds/utils';
import { useTheme } from 'react-jss';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _excluded$3 = ["palette", "spacing"];

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles$1 = createMemoStyles(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      theme = _objectWithoutProperties(_ref, _excluded$3);

  var pane = {
    bgColor: palette.background.accent,
    padding: spacing[5]
  };
  return {
    wrenchPane: function wrenchPane(_ref2) {
      var hide = _ref2.hide,
          transparent = _ref2.transparent;
      return _objectSpread$1(_objectSpread$1(_objectSpread$1({}, hide && visuallyHidden), defaultFonts(theme)), {}, {
        background: transparent ? 'none' : pane.bgColor
      });
    },
    wrenchPaneBody: function wrenchPaneBody() {
      return {
        padding: pane.padding
      };
    }
  };
});
var useStyles$2 = useStyles$1;
var _excluded$2 = ["children", "hide", "id", "padding", "labelledBy", "role", "transparent"];

var Pane = function Pane(_ref) {
  var children = _ref.children,
      hide = _ref.hide,
      id = _ref.id,
      padding = _ref.padding,
      labelledBy = _ref.labelledBy,
      role = _ref.role,
      transparent = _ref.transparent,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    hide: hide,
    transparent: transparent,
    theme: theme
  }),
      wrenchPane = _useStyles.wrenchPane,
      wrenchPaneBody = _useStyles.wrenchPaneBody;

  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: wrenchPane,
    role: role,
    id: id,
    "aria-labelledby": labelledBy,
    "aria-hidden": hide
  }, safeRest(rest)), padding ? /*#__PURE__*/React.createElement("div", {
    className: wrenchPaneBody
  }, children) : children);
};

Pane.displayName = "Pane";
Pane.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  hide: PropTypes.bool,
  id: PropTypes.string,
  padding: PropTypes.bool,
  labelledBy: PropTypes.string,
  role: PropTypes.string,
  transparent: PropTypes.bool
};
Pane.defaultProps = {
  hide: false,
  id: undefined,
  padding: false,
  labelledBy: undefined,
  role: undefined,
  transparent: false
};
var Pane$1 = Pane;
var TAB_COLORS = ["primary", "light", "dark", "transparent"];
var TAB_ALIGN = ["left", "right", "even", "center"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useStyles = createMemoStyles(function (theme) {
  var spacing = theme.spacing,
      border = theme.border,
      radius = theme.radius,
      palette = theme.palette,
      type = theme.type;
  var tab = {
    borderRadius: radius.zero,
    indicatorHeight: 3,
    indicatorColor: palette.primary.main,
    typeColor: palette.text.darkMuted,
    fontSize: type.fontSize.bodySm,
    fontWeight: type.fontWeight.medium,
    paddingY: spacing[3],
    paddingX: 2
  };

  var alignTabs = function alignTabs(align) {
    return {
      left: {
        justifyContent: 'flex-start'
      },
      right: {
        justifyContent: 'flex-end'
      },
      even: {
        justifyContent: 'center'
      },
      center: {
        whiteSpace: 'nowrap',
        textAlign: 'center'
      }
    }[align];
  };

  var alignTab = function alignTab(align) {
    return {
      left: {
        paddingLeft: spacing[5],
        '&:last-child': {
          paddingRight: spacing[5]
        }
      },
      right: {
        paddingRight: spacing[5],
        paddingLeft: 0,
        '&:first-child': {
          paddingLeft: spacing[5]
        }
      },
      even: {
        width: '100%',
        paddingLeft: 0,
        paddingRight: 0,
        grow: 1,
        overflow: 'hidden',
        textAlign: 'center'
      },
      center: {
        display: 'inline-block',
        padding: [0, spacing[3]]
      }
    }[align];
  };

  var colorTabs = function colorTabs(color) {
    return {
      primary: {
        background: palette.primary.main
      },
      light: {
        background: palette.background.light
      },
      dark: {
        background: palette.background.dark
      },
      transparent: {
        background: 'transparent',
        borderBottom: border.main
      }
    }[color];
  };

  var colorTabBtn = function colorTabBtn(color, selected) {
    return {
      primary: {
        color: palette.primary.contrast,
        borderBottom: selected ? [tab.indicatorHeight, 'solid', palette.primary.contrast] : 'none'
      },
      light: {
        color: selected ? tab.indicatorColor : palette.text.dark,
        borderBottom: selected ? [tab.indicatorHeight, 'solid', tab.indicatorColor] : 'none'
      },
      dark: {
        color: palette.text.light,
        borderBottom: selected ? [tab.indicatorHeight, 'solid', palette.text.light] : 'none'
      },
      transparent: {
        color: selected ? tab.indicatorColor : palette.text.dark,
        borderBottom: selected ? [tab.indicatorHeight, 'solid', tab.indicatorColor] : 'none'
      }
    }[color];
  };

  return {
    wrenchTabs: function wrenchTabs(_ref) {
      var align = _ref.align,
          color = _ref.color;
      return _objectSpread(_objectSpread(_objectSpread({}, defaultBaseline), {}, {
        // if align is set to center
        display: align === 'center' ? 'block' : 'flex',
        flexDirection: 'row',
        alignContent: 'flex-start',
        overflowX: 'auto',
        borderRadius: tab.borderRadius
      }, alignTabs(align)), colorTabs(color));
    },
    wrenchTab: function wrenchTab(_ref2) {
      var align = _ref2.align;
      return _objectSpread({
        boxSizing: 'border-box',
        margin: 0,
        backgroundColor: 'transparent'
      }, alignTab(align));
    },
    wrenchTabBtn: function wrenchTabBtn(_ref3) {
      var color = _ref3.color,
          selected = _ref3.selected,
          disabled = _ref3.disabled;
      return _objectSpread(_objectSpread({
        display: 'block',
        background: 'transparent',
        border: 'none',
        borderRadius: 0,
        padding: "".concat(tab.paddingY, "px ").concat(tab.paddingX, "px"),
        fontSize: tab.fontSize,
        fontWeight: tab.fontWeight,
        fontFamily: type.fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        cursor: 'pointer',
        width: '100%',
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto'
      }, colorTabBtn(color, selected)), {}, {
        '&:hover, &:focus': {
          textDecoration: 'none'
        }
      });
    }
  };
});
var _excluded$1 = ["align", "fullWidth", "color", "onChange", "children", "selectionFollowsFocus"];

var Tabs = function Tabs(_ref) {
  var align = _ref.align,
      fullWidth = _ref.fullWidth,
      color = _ref.color,
      onChange = _ref.onChange,
      children = _ref.children,
      selectionFollowsFocus = _ref.selectionFollowsFocus,
      rest = _objectWithoutProperties(_ref, _excluded$1); // Finds the first selected tab that is not set to disabled


  var getSelectedValue = useCallback(function () {
    var prevSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var selected = prevSelected;
    Children.forEach(children, function (child, index) {
      var _child$props;

      if (child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.selected && !child.props.disabled) {
        selected = child.props.value || index;
      }
    });
    return selected;
  }, [children]); // Initializes selectedValue with either null or first tab that has selected=true

  var _useState = useState(getSelectedValue),
      _useState2 = _slicedToArray(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1]; // When controlled selected value changes in children, this will change selected value


  useEffect(function () {
    setSelectedValue(getSelectedValue);
  }, [getSelectedValue]); // Creates a uniqueID for this Tabs component

  var uniqueTabName = useMemo(function () {
    return uniqueId('wds-tab-');
  }, []);
  var tabListRef = useRef(null);
  var tabRef = useRef(null);
  var paneRef = useRef(null);
  var theme = useTheme();
  var classes = useStyles({
    color: color,
    theme: theme,
    align: align
  });

  var handleChange = function handleChange(evt, newFocusTarget, value, id) {
    if (newFocusTarget !== null) {
      //  This allows for selectionFollowsFocus case
      if (evt.key === KEYS.SPACE || evt.key === KEYS.ENTER || evt.type === 'click' || selectionFollowsFocus) {
        setSelectedValue(value);
      }

      newFocusTarget.focus();
      evt.preventDefault();

      if (onChange) {
        onChange(evt, newFocusTarget, value, id);
      }
    }
  };

  var handleKeyPress = function handleKeyPress(evt, id) {
    var key = evt.key,
        target = evt.target;
    var role = target.getAttribute('role');

    if (role !== 'tab' || !Object.values(KEYS).includes(key)) {
      return;
    } // This will create an array of tab button elements and filter out any disabled tabs


    var tabListFlat = _toConsumableArray(tabListRef.current.children).map(function (tab) {
      return tab.firstChild;
    }).filter(function (tab) {
      return !tab.disabled;
    });

    var tabListLength = tabListFlat.length - 1;
    var tabIndex = tabListFlat.indexOf(target);
    var newFocusTarget = null;

    switch (evt.key) {
      // Handles when TAB is pressed
      case KEYS.TAB:
        if (paneRef.current) {
          paneRef.current.focus();
          evt.preventDefault();
        }

        return;
      // When RIGHT or DOWN is pressed to goto the next focused tab

      case KEYS.RIGHT:
      case KEYS.DOWN:
        newFocusTarget = tabIndex < tabListLength ? tabListFlat[tabIndex + 1] : tabListFlat[0];
        break;
      // When LEFT or UP is pressed to goto the previous focused tab

      case KEYS.LEFT:
      case KEYS.UP:
        newFocusTarget = tabIndex !== 0 ? tabListFlat[tabIndex - 1] : tabListFlat[tabListLength];
        break;
      // When HOME is pressed to goto the first tab

      case KEYS.HOME:
        var _tabListFlat = _slicedToArray(tabListFlat, 1);

        newFocusTarget = _tabListFlat[0];
        break;
      // When END is pressed to goto the last tab

      case KEYS.END:
        newFocusTarget = tabListFlat[tabListLength];
        break;

      case KEYS.SPACE:
      case KEYS.ENTER:
        newFocusTarget = evt.target;
        break;
    }

    if (newFocusTarget !== null) {
      handleChange(evt, newFocusTarget, parseInt(newFocusTarget.value, 10), id);
    }
  };

  var renderTabElement = function renderTabElement(child, value, selected, id) {
    return /*#__PURE__*/cloneElement(child, {
      children: child.props.title,
      ref: selected ? tabRef : undefined,
      key: value,
      id: id,
      selected: selected,
      align: align,
      color: color,
      value: value,
      onKeyDown: handleKeyPress,
      onChange: handleChange
    });
  };

  var renderPaneElement = function renderPaneElement(paneChildren, value, selected, id) {
    var paneProps = fullWidth ? {
      transparent: true
    } : {
      padding: true
    };
    return /*#__PURE__*/React.createElement("section", {
      ref: selected ? paneRef : undefined,
      key: value,
      role: "tabpanel",
      tabIndex: 0,
      "aria-labelledby": id,
      "aria-hidden": !selected
    }, /*#__PURE__*/React.createElement(Pane$1, Object.assign({}, paneProps, {
      hide: !selected
    }), paneChildren));
  };

  var tabList = [];
  var paneList = [];
  Children.forEach(children, function (child, index) {
    if (! /*#__PURE__*/isValidElement(child)) {
      return;
    }

    var id = child.props.id || "".concat(uniqueTabName, "-").concat(index);
    var childValue = child.props.value || index;
    var selected = childValue === selectedValue;
    tabList.push(renderTabElement(child, childValue, selected, id));

    if (child.props.children) {
      paneList.push(renderPaneElement(child.props.children, childValue, selected, id));
    }
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", Object.assign({
    role: "tablist",
    ref: tabListRef,
    className: classes.wrenchTabs
  }, safeRest(rest)), tabList), /*#__PURE__*/React.createElement("div", {
    className: classes.tabPanes
  }, paneList));
};

Tabs.displayName = "Tabs";
Tabs.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(TAB_ALIGN),
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  selectionFollowsFocus: PropTypes.bool,
  color: PropTypes.oneOf(TAB_COLORS)
};
Tabs.defaultProps = {
  children: undefined,
  align: 'left',
  fullWidth: false,
  onChange: undefined,
  color: 'light',
  selectionFollowsFocus: true
};
var _excluded = ["selected", "disabled", "id", "align", "color", "value", "onKeyDown", "onChange", "children"];
var Tab = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled,
      id = _ref.id,
      align = _ref.align,
      color = _ref.color,
      value = _ref.value,
      onKeyDown = _ref.onKeyDown,
      onChange = _ref.onChange,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var classes = useStyles({
    selected: selected,
    disabled: disabled,
    align: align,
    color: color,
    theme: theme
  });

  var handleChange = function handleChange(evt) {
    onChange(evt, evt.target, value, id);
  };

  var handleKeyPress = function handleKeyPress(evt) {
    if (onKeyDown) {
      onKeyDown(evt, id);
    }
  };

  return /*#__PURE__*/React.createElement("li", Object.assign({
    role: "presentation",
    className: classes.wrenchTab,
    onKeyDown: handleKeyPress
  }, safeRest(rest)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    role: "tab",
    "aria-selected": selected,
    "aria-disabled": disabled,
    disabled: disabled,
    value: value,
    tabIndex: disabled || !selected ? -1 : 0,
    onClick: handleChange,
    className: classes.wrenchTabBtn,
    id: id,
    ref: ref
  }, children));
});
Tab.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  align: PropTypes.oneOf(TAB_ALIGN),
  color: PropTypes.oneOf(TAB_COLORS),
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  selected: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Tab.defaultProps = {
  children: '',
  disabled: false,
  id: undefined,
  align: 'left',
  color: 'light',
  onChange: undefined,
  onKeyDown: undefined,
  selected: false,
  value: 0
};
export { TAB_ALIGN, TAB_COLORS, Tab, Tabs };